import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YaMetricComponent } from '../ya-metric/ya-metric.component';
import { Observable } from 'rxjs';
import { ConfigRepository } from '../../../../shared/repositories/config.repository';

@Component({
  selector: 'app-lazy-metric-main',
  standalone: true,
  imports: [CommonModule, YaMetricComponent],
  templateUrl: './lazy-metric-main.component.html',
})
export class LazyMetricMainComponent {
  codes$: Observable<string[] | null | undefined> = inject(ConfigRepository).yAnalyticsCodes$;
}
